import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { TextAreaComponent } from '../../../../common/text-area/text-area.component';
import { TrackUnsavedFieldBase } from '../../../../base/track-unsaved-field-base';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ReviewRequest } from '../../../../../../shared/models/dtc/reviewRequest';
import { STORAGE_KEYS } from '../../../../../../shared/constants/storage-keys';
import { AddComponent } from '../../../../icons/add/add.component';
import { FloppyIconComponent } from '../../../../icons/floppy-icon/floppy-icon.component';
import { DeleteIconComponent } from '../../../../icons/delete-icon/delete-icon.component';
import { AgentActionDirective } from '../../../../../directives/agent-action.directive';

// TODO: Support disabled mode
@Component({
  selector: 'app-review-request-fields',
  imports: [
    TextAreaComponent,
    ReactiveFormsModule,
    AddComponent,
    FloppyIconComponent,
    DeleteIconComponent,
    AgentActionDirective,
  ],
  templateUrl: './review-request-fields.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './review-request-fields.scss',
})
export class ReviewRequestFields extends TrackUnsavedFieldBase<ReviewRequest> implements OnChanges {
  @Input() public editReviewEnabled = false;
  @Input() public showCreateButton = false;
  @Input() public createReviewDisabled = false;

  @Output() public reviewDiscardClicked = new EventEmitter<ReviewRequest>();
  @Output() public reviewUpsertClicked = new EventEmitter<ReviewRequest>();

  protected override readonly formGroup: FormGroup<{
    id: FormControl<string | null>;
    entityId: FormControl<string | null>;
    causeIntern: FormControl<string | null>;
    causeDealer: FormControl<string | null>;
    causeFarmer: FormControl<string | null>;
    remedyIntern: FormControl<string | null>;
    remedyDealer: FormControl<string | null>;
    remedyFarmer: FormControl<string | null>;
    reviewNotes: FormControl<string | null>;
    rowVersion: FormControl<number | null>;
  }>;

  constructor() {
    super(STORAGE_KEYS.UNSAVED_DTC_REVIEW_REQUEST_CHANGES);
    this.formGroup = this.formBuilder.group({
      id: new FormControl<string | null>(null, []),
      entityId: new FormControl<string | null>(null, []),
      causeIntern: new FormControl<string | null>(null, []),
      causeDealer: new FormControl<string | null>(null, []),
      causeFarmer: new FormControl<string | null>(null, []),
      remedyIntern: new FormControl<string | null>(null, []),
      remedyDealer: new FormControl<string | null>(null, []),
      remedyFarmer: new FormControl<string | null>(null, []),
      reviewNotes: new FormControl<string | null>(null, []),
      rowVersion: new FormControl<number | null>(null, []),
    });
  }

  public ngOnChanges(): void {
    this.formGroup.patchValue(
      this.item ?? {
        id: null,
        entityId: null,
        causeIntern: null,
        causeDealer: null,
        causeFarmer: null,
        remedyIntern: null,
        remedyDealer: null,
        remedyFarmer: null,
        reviewNotes: null,
        rowVersion: null,
      }
    );
    this.resetFieldTracking$.next(undefined);
    this.previousItemId = this.item?.id;
  }

  protected override getCurrentItemFromFormValues(): ReviewRequest {
    return {
      id: this.formGroup.get('id')?.value ?? undefined,
      entityId: this.formGroup.get('entityId')?.value ?? undefined,
      causeIntern: this.formGroup.get('causeIntern')?.value ?? undefined,
      causeDealer: this.formGroup.get('causeDealer')?.value ?? undefined,
      causeFarmer: this.formGroup.get('causeFarmer')?.value ?? undefined,
      remedyIntern: this.formGroup.get('remedyIntern')?.value ?? undefined,
      remedyDealer: this.formGroup.get('remedyDealer')?.value ?? undefined,
      remedyFarmer: this.formGroup.get('remedyFarmer')?.value ?? undefined,
      reviewNotes: this.formGroup.get('reviewNotes')?.value ?? undefined,
      // reviewerRole: this.formGroup.get('reviewerRole')?.value ?? undefined,
      rowVersion: this.formGroup.get('rowVersion')?.value ?? undefined,
      changed: true,
    };
  }

  protected emitReviewDiscarded(): void {
    this.item = this.getCurrentItemFromFormValues();
    this.reviewDiscardClicked.emit(this.item);
  }

  protected emitReviewUpserted(): void {
    this.item = this.getCurrentItemFromFormValues();
    this.reviewUpsertClicked.emit(this.item);
  }
}
